import { camelToDisplay, transposeValues } from '@iotv/datamodel-core';
import { AppValueTypes, setAContainsAllB } from '@iotv/iotv-v3-types';
import { v4 as uuidv4 } from 'uuid';
import Assembler from '../../data/Assembler';
import { getPseudoVBO } from '../../data/TypeHelpers';
import { clearSheet, updateValues } from '../../Google/Sheets/sheetFns';
const debug = process.env.REACT_APP_DEBUG && false;
export const rangeFromSheetAndCol = (sheetName, startCol, endCol, startRow, endRow) => `${sheetName ? `${sheetName}!` : ''}${startCol}${startRow ?? ''}:${endCol ?? startCol}${endRow ?? ''}`;
export const LIA = 26, A = 65;
export const ziToC = (zi) => {
    if (typeof zi === 'number') {
        const C = [];
        let quo = 0, mod = 0;
        do {
            mod = zi % LIA;
            quo = Math.floor(zi / LIA);
            zi = quo - 1;
            debug && console.log({ col: zi, mod, quo });
            C.unshift(String.fromCharCode(mod + A));
        } while (quo !== 0);
        return C.join('');
    }
    else
        return '';
};
export const isValidA1Notation = (a1Range) => a1Range && /^([A-Z]+(\d+)?):([A-Z]+(\d+)?)$/.test(a1Range);
export const firstRowToHeaders = (headerRow) => {
    const columnIndexedKeys = (headerRow ?? []).reduce((a, c, i) => {
        let headerVal;
        if (typeof c === 'string' && c.length > 1) {
            headerVal = c;
        }
        else {
            headerVal = ziToC(i);
        }
        a.push(headerVal);
        return a;
    }, []);
    return columnIndexedKeys;
};
export var HeaderSource;
(function (HeaderSource) {
    HeaderSource["LABEL"] = "key";
    HeaderSource["KEY"] = "key";
})(HeaderSource || (HeaderSource = {}));
export const exportVobs = async ({ vobs, viewDefinition, file, sheet, headerSource = HeaderSource.KEY, processPlainObjects }) => {
    const result = { err: null, data: null };
    debug && console.log('exporting ', { vobs, file, sheet });
    if (!viewDefinition.id && !processPlainObjects) {
        const id = {
            key: 'id',
            label: 'id',
            editable: false,
            precision: undefined,
            stateFn: undefined,
            type: AppValueTypes.STRING,
            unit: undefined,
            validationRx: undefined,
        };
        viewDefinition.id = id;
        debug && console.log('Added ID to view Defintion', viewDefinition);
    }
    const a1Range = `${sheet.properties?.title}!A1`;
    if (file.id) {
        const params = {
            // The ID of the spreadsheet to update.
            spreadsheetId: file.id,
            // The A1 notation of the values to update.
            range: a1Range, // TODO: Update placeholder value.
            // How the input data should be interpreted.
            valueInputOption: 'USER_ENTERED', // TODO: Update placeholder value.
        };
        const headerRow = Object.entries(viewDefinition).map(([k, def]) => {
            return def[headerSource];
        });
        debug && console.log('vob s', vobs, viewDefinition);
        const rows = vobs
            .map((vob) => {
            return Assembler.getInstance(vob) ?? vob;
        })
            .map((vob) => {
            debug && console.log('vob', vob, viewDefinition);
            return Object.entries(viewDefinition).map(([k, def]) => vob[def.key] ?? null);
        });
        const values = [headerRow, ...rows];
        await clearSheet(params);
        const valueRangeBody = {
            range: a1Range,
            majorDimension: 'ROWS',
            values,
        };
        const updateRes = await updateValues(params, valueRangeBody);
        result.err = updateRes.err;
        result.data = updateRes.data;
    }
    else {
        debug && console.log('No spreadsheet id', file);
    }
    return result;
};
const extractGeometry = (geometryString) => {
    const pointRegex = /POINT \((\d+\.\d+) (-?\d+\.\d+)\)/;
    const polygonRegex = /POLYGON \(\(([\d\s\.,-]+)\)\)/;
    const pointMatch = geometryString.match(pointRegex);
    const polygonMatch = geometryString.match(polygonRegex);
    if (pointMatch) {
        const newLocation = {
            lat: parseFloat(pointMatch[2]),
            lng: parseFloat(pointMatch[1]),
        };
        return {
            // type: 'Place',
            location: newLocation,
        };
    }
    else if (polygonMatch) {
        const coordinatesStr = polygonMatch[1].split(',').map((str) => str.trim());
        const coordinates = coordinatesStr.map((coord) => {
            const [lng, lat] = coord.split(' ').map(parseFloat);
            const id = uuidv4();
            return { id, lat, lng };
        });
        return {
            // type: 'Area',
            points: coordinates,
            lastPoint: coordinates.length > 0 && coordinates[0],
        };
    }
    else {
        throw new Error('Invalid geometry format');
    }
};
/** this is poluted with Area handling clauses */
const rowToObject = ({ rowNumber, rowArr, headerRow, importObjectType, setImportObjectType, requireUniqueId, }) => {
    let required = ['type', 'id'];
    let res = undefined;
    if (setAContainsAllB(headerRow, required) && !headerRow.includes('WKT')) {
        debug && console.log('hah, why goes here?', headerRow, required);
        const proxy = {};
        headerRow.forEach((key, i) => {
            if (key.includes('#')) {
                let mod = key.replace('#', '');
                proxy[mod] = parseInt(rowArr[i]) ? parseInt(rowArr[i]) : rowArr[i];
            }
            else {
                proxy[key] = rowArr[i];
            }
            if (key === 'type' && !importObjectType) {
                debug && console.log('setting import type to', rowArr[i]);
                setImportObjectType(rowArr[i]);
            }
        });
        res = getPseudoVBO(proxy);
    }
    else {
        if (headerRow.includes('WKT')) {
            // import objects with WKT
            const proxy = { type: importObjectType ?? 'Unknown', id: requireUniqueId ? uuidv4() : rowNumber };
            debug && console.log('import proxy', proxy);
            debug && console.log('import ');
            const id = uuidv4();
            const targetKeys = ['name', 'description', 'type', 'id', 'sk', 'pk'];
            headerRow.forEach((key, i) => {
                /** geo */
                if (key === 'WKT') {
                    const geo = extractGeometry(rowArr[i]);
                    Object.entries(geo).forEach(([key, value]) => {
                        debug && console.log('why points in Place?', key, value, proxy);
                        if (key && value) {
                            proxy[key] = value;
                        }
                    });
                }
                /** emmm change this */
                if (targetKeys.includes(key)) {
                    proxy[key] = rowArr[i];
                }
                debug && console.log('rowArr[i]', rowArr);
                if (!importObjectType) {
                    debug && console.log(`setting import type to ${proxy.type}`);
                    setImportObjectType(proxy.type);
                }
                // delete proxy.WKT
                res = getPseudoVBO(proxy);
                debug && console.log('res', res);
            });
        }
        else {
            const proxy = { type: importObjectType ?? 'Unknown', id: requireUniqueId ? uuidv4() : rowNumber };
            headerRow.forEach((key, i) => {
                proxy[key] = rowArr[i];
                if (!importObjectType) {
                    debug && console.log(`setting import type to ${proxy.type}`);
                    setImportObjectType(proxy.type);
                }
                res = getPseudoVBO(proxy);
            });
        }
    }
    return res;
};
export const spreadsheetDataAsVBOs = ({ spreadsheetData, importObjectType, setImportObjectType, processPlainObjects, requireUniqueId, }) => {
    let res = [];
    if (spreadsheetData.length > 0) {
        const [firstRow, ...rows] = spreadsheetData;
        const headerRow = firstRowToHeaders(firstRow);
        res = rows
            .map((rowArr, rowNumber) => rowToObject({ rowNumber, rowArr, headerRow, importObjectType, setImportObjectType, requireUniqueId }))
            .filter((vbo) => vbo);
    }
    debug && console.log('sheetDataAsVBOs res', res);
    return res;
};
export const spreadsheetDataToViewDefintion = ({ spreadsheetData }) => {
    let res = {};
    if (spreadsheetData.length > 0) {
        const [firstRow, ...rows] = spreadsheetData;
        const headerRow = firstRowToHeaders(firstRow);
        headerRow.forEach((headerCellContent) => {
            //handle header for number inputs
            let header = headerCellContent.replace('#', '');
            res[header] = {
                key: header,
                editable: false,
                label: header,
                precision: undefined,
                stateFn: undefined,
                type: AppValueTypes.STRING,
                unit: undefined,
                validationRx: undefined,
            };
        });
    }
    debug && console.log('sheetDataToViewDefintion res', res);
    return res;
};
// aims to be compatible with google-services version so can be injected into @datamodel methods
export const listRange = async (target) => {
    const res = { err: null, data: null };
    try {
        const getRes = await gapi.client.sheets.spreadsheets.values.get(target);
        debug && console.log('listRange', JSON.stringify(listRange, null, 1));
        if (getRes.result.values) {
            res.data = { values: getRes.result.values };
        }
        else {
            console.log('WARN No catch but no res data values', getRes.result);
        }
    }
    catch (error) {
        console.log('Err Caught Error', error);
        res.err = new Error(error.result.error.message);
    }
    return res;
};
/** ducktypes to AppValueTypes */
const duckType = (c) => {
    let resolvedType = null;
    const type = typeof c;
    const isArray = c && c instanceof Array;
    if (type === 'object') {
        resolvedType = AppValueTypes.OBJECT;
    }
    else if (type === 'string') {
        resolvedType = AppValueTypes.STRING;
    }
    else if (type === 'number') {
        resolvedType = AppValueTypes.NUMBER;
    }
    else if (type === 'boolean') {
        resolvedType = AppValueTypes.BOOLEAN;
    }
    return resolvedType;
};
/** produces an array of AppValueTypes cotained in a spreadsheetRow, used to generate cell render fns */
export const getUniqueDuckTypesInColumn = (col) => col.reduce((a, c) => {
    const type = duckType(c);
    if (type && !a.includes(type)) {
        a.push(type);
    }
    return a;
}, []);
export const getUnqiqueDuckTypeByColumn = (spreadSheetDataWithHeaders) => {
    const [headers, ...rows] = spreadSheetDataWithHeaders;
    const cols = transposeValues(rows);
    return Object.fromEntries(headers.map((k, i) => [k, getUniqueDuckTypesInColumn(cols[i])]));
};
export const getUniqueTypesMap = (records) => {
    const x = records.reduce((a, c) => {
        Object.entries(c).forEach(([k, v]) => {
            const type = duckType(v);
            if (!a[k])
                a[k] = [];
            if (type && !a[k].includes(type)) {
                a[k].push(type);
            }
        });
        return a;
    }, {});
    return x;
};
const getViewKeyDefinitionFromAppValueTypes = (key, uniqueAppValueTypes) => {
    const viewKeyDefinition = {
        key,
        label: camelToDisplay(key),
        type: AppValueTypes.STRING,
        editable: false,
    };
    if (uniqueAppValueTypes.length === 1) {
        viewKeyDefinition.type = uniqueAppValueTypes[0];
    }
    else if (!uniqueAppValueTypes.includes(AppValueTypes.OBJECT)) {
        // leave as STRING
    }
    if (viewKeyDefinition.type === AppValueTypes.OBJECT) {
        viewKeyDefinition.valueGetter = (v) => JSON.stringify(v);
        viewKeyDefinition.valueSetter = (s) => {
            let res = s;
            try {
                res = JSON.parse(s);
            }
            catch (e) {
                // silent
            }
            return res;
        };
    }
    return viewKeyDefinition;
};
export const getViewDefinitionFromUniqueKeyTypes = (unqiueTypeMap) => {
    const viewDefinition = Object.fromEntries(Object.entries(unqiueTypeMap).map(([k, v]) => [k, getViewKeyDefinitionFromAppValueTypes(k, v ?? [AppValueTypes.STRING])]));
    return viewDefinition;
};
